import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface AlertData {
  type: 'success' | 'danger' | 'warning';
  message: string;
  icon: string;
}

@Injectable({ providedIn: 'root' })
export class ApiMessageService {
  private readonly alertSubject = new BehaviorSubject<AlertData | null>(null);
  alert$ = this.alertSubject.asObservable();

  private currentTimeout: any = null;

  private show(type: AlertData['type'], message: string, icon: string) {
    // Limpa o timeout anterior se existir
    if (this.currentTimeout) {
      clearTimeout(this.currentTimeout);
      this.currentTimeout = null;
    }

    this.alertSubject.next({ type, message, icon });
  }

  showSuccess(message: string) {
    this.show('success', message, 'fas fa-check-circle');
  }

  showError(message: string) {
    this.show('danger', message, 'fas fa-exclamation-triangle');
  }

  showWarning(message: string) {
    this.show('warning', message, 'fas fa-exclamation-circle');
  }

  clear() {
    // Limpa o timeout se existir
    if (this.currentTimeout) {
      clearTimeout(this.currentTimeout);
      this.currentTimeout = null;
    }

    this.alertSubject.next(null);
  }

  /**
   * Define o timeout e retorna o ID para ser armazenado
   */
  setAutoCloseTimeout(callback: () => void, type: string): void {
    // Limpa timeout anterior
    if (this.currentTimeout) {
      clearTimeout(this.currentTimeout);
    }

    const timeout = this.getTimeoutForAlertType(type);

    this.currentTimeout = setTimeout(() => {
      callback();
      this.currentTimeout = null;
    }, timeout);
  }

  /**
   * Retorna o timeout apropriado baseado no tipo de alerta
   */
  getTimeoutForAlertType(type: string): number {
    switch (type) {
      case 'success':
        return 4000; // 4 segundos para sucesso
      case 'danger':
        return 6000; // 6 segundos para erro
      case 'warning':
        return 6000; // 6 segundos para aviso
      default:
        return 3000; // padrão 3 segundos
    }
  }
}
